import React from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";
import { FaRegCopy } from "react-icons/fa";
import { toast } from "sonner";
const UnitDetailsModal = ({
  showDetailsModal,
  selectedUnit,
  closeDetails,
  apiName,
}) => {
  return (
    <Modal
      show={showDetailsModal}
      onHide={() => {
        closeDetails();
      }}
      centered
      backdrop="static"
      className="text-light"
      size="lg"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title className="text-light">Ad Unit Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Row>
          {Object.entries({
            ID: selectedUnit?.id || "",
            "Unit Name": selectedUnit.name || "",
            Format: selectedUnit?.ad_format || "",
            Type: selectedUnit?.type || "",
            Provider: apiName || "",
            Status: selectedUnit.status === 1 ? "Active" : "Inactive",
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div
                className="p-3 bg-secondary bg-opacity-10 rounded"
                style={{ overflow: "auto" }}
              >
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span
                  className={`d-block fs-5 fw-medium ${!value && "text-danger"}`}
                >
                  {value || "N/A"}
                </span>
              </div>
            </Col>
          ))}
          <Col xs={12} md={12} lg={12} className="mb-3">
            <div
              className="p-3 bg-secondary bg-opacity-10 rounded d-flex justify-content-between align-items-start"
              style={{ overflow: "auto" }}
            >
              <div>
                <span className="text-secondary fs-6 fw-semibold d-block">
                  Code / URL
                </span>
                <span
                  className={`d-block ${
                    selectedUnit?.code_url
                      ? "fs-6 fw-small text-break"
                      : "text-danger fs-5 fw-medium"
                  }`}
                >
                  {selectedUnit?.code_url || "N/A"}
                </span>
              </div>

              {selectedUnit?.code_url && (
                <Button
                  variant="light"
                  size="md"
                  className="ms-2"
                  title="copy to clipboard"
                  onClick={() =>
                    navigator.clipboard
                      .writeText(selectedUnit.code_url)
                      .then(() => toast.success("Copied to clipboard"))
                      .catch((err) => toast.error("Failed to copy"))
                  }
                >
                  <FaRegCopy />
                </Button>
              )}
            </div>
          </Col>
          <Col xs={12} md={12} lg={12} className="mb-3">
            <div
              className="p-3 bg-secondary bg-opacity-10 rounded d-flex justify-content-between align-items-start"
              style={{ overflow: "auto" }}
            >
              <div>
                <span className="text-secondary fs-6 fw-semibold d-block">
                  IMA(Google Interactive Media Ad) URL
                </span>
                <span
                  className={`d-block ${
                    selectedUnit?.IMA_url
                      ? "fs-6 fw-small text-break"
                      : "text-danger fs-5 fw-medium"
                  }`}
                >
                  {selectedUnit?.IMA_url || "N/A"}
                </span>
              </div>

              {selectedUnit?.IMA_url && (
                <Button
                  variant="light"
                  size="md"
                  className="ms-2"
                  title="copy to clipboard"
                  onClick={() =>
                    navigator.clipboard
                      .writeText(selectedUnit.IMA_url)
                      .then(() => toast.success("Copied to clipboard"))
                      .catch((err) => toast.error("Failed to copy"))
                  }
                >
                  <FaRegCopy />
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default UnitDetailsModal;
